import { render } from "./container-bulk-import.vue?vue&type=template&id=a5098e2a&scoped=true"
import script from "./container-bulk-import.vue?vue&type=script&lang=js"
export * from "./container-bulk-import.vue?vue&type=script&lang=js"

import "./container-bulk-import.vue?vue&type=style&index=0&id=a5098e2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5098e2a"]])

export default __exports__